import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Card = styled.div<{ stepIndex: number }>`
  background-color: var(--brand-secondary);
  color: white;
  padding: 1.2rem;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: min(26rem, 60%);
  position: fixed;
  top: ${({ stepIndex }) => `${50 + stepIndex * 50}px`};
  left: 60px;
  z-index: 1010;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const Arrow = styled.div`
  position: absolute;
  top: 20px;
  left: -10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid var(--brand-secondary);
  z-index: 1001;
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin: 0;
`;

export const Content = styled.div`
  font-size: 14px;
  margin-top: 0.5rem;
`;

export const ButtonContainer = styled.div<{ buttonCount: number }>`
  display: flex;
  justify-content: ${({ buttonCount }) => (buttonCount === 1 ? 'flex-end' : 'space-between')};
  gap: 8px;
  margin-top: 1rem;
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  background: var(--brand-primary);
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background: var(--brand-primary-dark);
  }
`;

